(function() {

	$( document ).ready(function() {

		var form = $( '.form-contact-form' );

		form.submit( function( event ){

			$( '.form-contact-submit-button' ).css('background-color', '#ffffff');
			$( '.form-contact-submit-button').html('Loading...');

			event.preventDefault();

			$.ajax({
				url : $(this).attr( 'action' ),
				method : $(this).attr( 'method' ),
				data : $(this).serialize(),
				success : function( res ) {

					$( '#form-contact-first-name' ).val( '' );
					$( '#form-contact-last-name' ).val( '' );
					$( '#form-contact-email' ).val( '' );
					$( '.input-group', form ).css( "display", "none" );
					$( '.form-contact-submit' ).css( "display", "none" );
					$( '.form-newsletter-submit-button').css( 'background-color', '#D13239');
					$( '.form-newsletter-submit-button').html( window.theme.contact.button );

					$( '.form-contact-message', form ).append( "<p>"+ window.theme.contact.success +"</p>" );

				},
				error : function( err ){

					$( '#form-contact-first-name' ).val( '' );
					$( '#form-contact-last-name' ).val( '' );
					$( '#form-contact-email' ).val( '' );
					$( '.input-group', form ).css( "display", "none" );
					$( '.form-contact-submit' ).css( "display", "none" );
					$( '.form-newsletter-submit-button').css( 'background-color', '#D13239');
					$( '.form-newsletter-submit-button').html('Contact Us');

					$( '.form-contact-message', form ).append( "<p>" + window.theme.contact.error + "</p>" );

				}
			});

			return false;


		});

	});

})();
